const styles = {
  instName: {
    fontWeight: "bold",
    fontSize: "30px",
    marginTop: "50px",
    marginBottom: "20px",
  },
  container: {
    fontFamily: ({ theme }) => theme.fontFamily,
    width: "70%",
    margin: "0 auto",
    "@media (max-width: 1200px)": {
      width: "90%",
    },
  },
  actionLinks: {
    marginBottom: "20px",
  },
};

export default styles;
